import React from 'react';
import { Text } from '@radix-ui/themes';

interface CsGroupOrderProps {
  data: Array<{ id: string; group_name?: string; table_name?: string }>;
  tableData: { table_name?: string };
}

const CsGroupOrder: React.FC<CsGroupOrderProps> = ({ data, tableData }) => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center">
      <Text className="text-white font-[Lato-Regular] text-sm">
        Order of Presentations
      </Text>
      <Text className="text-white font-[Lato-Regular] text-[10px] mt-1">
        Only the Presenter’s screen will be shared with everyone.
      </Text>
      <div className="max-h-[40vh] my-4 overflow-y-auto scrollbar-hidden">
        {data.map((item, index) => (
          <div
            key={item.id}
            className="flex flex-row items-center w-[60vw] px-4 py-2 rounded-lg bg-[rgba(255,255,255,0.5)] mt-2 justify-between"
          >
            <Text className="font-[Lato-Bold] text-white text-xl">
              # {index + 1}
            </Text>
            <Text className="font-[Lato-Bold] text-blue-600 text-lg">
              {item?.group_name || item?.table_name}
            </Text>
            <Text
              className={`font-[Lato-Regular] text-gray-500 text-xs ${
                tableData?.table_name === (item?.group_name || item?.table_name) ? 'opacity-100' : 'opacity-0'
              }`}
            >
              Your Group
            </Text>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CsGroupOrder;